import { ApolloError } from '@apollo/client';
import React from 'react';

export const GraphErrorDisplay = ({
  error,
}: {
  error: ApolloError | { message: React.ReactNode };
}) => (
  <div className="flex flex-1 items-center justify-center">
    <div className="max-w-md text-center">
      <div className="mb-4 text-3xl">Error loading graphs</div>
      <div className="mb-4 text-placeholder">{error.message}</div>
    </div>
  </div>
);
